
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Boatclubroadmumbaicab() {



    const cardData =
    {
        keyword: 'Boat Club Road to Mumbai Cab',
        heading: 'Meghana Cab : Boat Club Road to Mumbai Cab',
        headingDescription: 'Meghana Cab offers Boat Club Road to Mumbai Cab service, providing a premium and seamless travel experience from one of Pune’s most upscale localities to the bustling city of Mumbai. Whether it’s a corporate journey, airport transfer, or a leisure trip, our range of well-maintained vehicles—including Sedans, SUVs, Innova Crysta, and Tempo Travellers—ensures maximum comfort and safety. Enjoy door-to-door pickup from Boat Club Road, courteous chauffeurs, transparent pricing, and 24/7 customer assistance. Book your Boat Club Road to Mumbai Cab with Meghana Cab and experience top-notch intercity travel with ease and elegance.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

    "services": [
    {
      "name": "Boat Club Road to Mumbai Taxi Booking",
      "description": "Easily book your taxi from Boat Club Road to Mumbai with our user-friendly online platform. Choose from a range of vehicles and enjoy a hassle-free booking experience with instant confirmation."
    },
    {
      "name": "One Way Cab Boat Club Road to Mumbai",
      "description": "Opt for our efficient one-way taxi service for a seamless journey from Boat Club Road to Mumbai. Ideal for quick transfers without any detours or delays."
    },
    {
      "name": "Round Trip Cab Boat Club Road to Mumbai",
      "description": "Plan your round trip travel between Boat Club Road and Mumbai with our affordable and reliable cab services, ensuring you have a cab ready for both onward and return journeys."
    },
    {
      "name": "AC Cab Hire Boat Club Road to Mumbai",
      "description": "Travel in comfort with our air-conditioned cabs, perfect for beating the heat and enjoying a smooth ride from Boat Club Road to Mumbai."
    },
    {
      "name": "Budget Taxi Boat Club Road to Mumbai",
      "description": "Avail budget-friendly taxi services without compromising on quality. Our economical options from Boat Club Road to Mumbai provide great value for your money."
    },
    {
      "name": "SUV Cabs Boat Club Road to Mumbai",
      "description": "Hire spacious and comfortable SUV cabs suitable for family trips, group travel, or when extra luggage space is needed for your Boat Club Road to Mumbai journey."
    },
    {
      "name": "Online Booking Boat Club Road to Mumbai Taxi",
      "description": "Book your taxi online conveniently with real-time availability and secure payment options. Plan your trip from Boat Club Road to Mumbai with confidence."
    },
    {
      "name": "Sedan Hire Boat Club Road to Mumbai",
      "description": "Choose from a range of well-maintained sedans offering comfort and style for your ride from Boat Club Road to Mumbai, ideal for business and personal travel."
    },
    {
      "name": "Private Cab Boat Club Road to Mumbai",
      "description": "Enjoy exclusive and private cab services, ensuring a direct and personalized journey from Boat Club Road to Mumbai without unnecessary stops."
    },
    {
      "name": "Chauffeur Driven Taxi Boat Club Road to Mumbai",
      "description": "Experience professional chauffeur-driven taxi services, guaranteeing safe and timely travel with courteous drivers familiar with the Boat Club Road to Mumbai route."
    },
    {
      "name": "Family Cab Boat Club Road to Mumbai",
      "description": "Our family-friendly cabs ensure a comfortable and safe journey for all family members traveling from Boat Club Road to Mumbai."
    },
    {
      "name": "Corporate Cab Boat Club Road to Mumbai",
      "description": "Tailored corporate cab services for business travelers between Boat Club Road and Mumbai, offering punctuality, professionalism, and convenience."
    },
    {
      "name": "Reliable Cab Boat Club Road to Mumbai",
      "description": "Count on our reliable taxi services with timely pickups, clean vehicles, and experienced drivers to ensure a smooth journey from Boat Club Road to Mumbai."
    },
    {
      "name": "Fast Travel Cab Boat Club Road to Mumbai",
      "description": "Benefit from our quick and efficient taxi booking system designed to reduce wait times and get you to Mumbai from Boat Club Road swiftly."
    },
    {
      "name": "24/7 Cab Booking Boat Club Road to Mumbai",
      "description": "Avail round-the-clock taxi booking services, ensuring you can travel any time of day or night between Boat Club Road and Mumbai with ease and safety."
    }
  ],
  "tableData": [
    ["Boat Club Road to Mumbai Taxi Booking", "One Way Cab Boat Club Road to Mumbai"],
    ["Round Trip Cab Boat Club Road to Mumbai", "AC Cab Hire Boat Club Road to Mumbai"],
    ["Budget Taxi Boat Club Road to Mumbai", "SUV Cabs Boat Club Road to Mumbai"],
    ["Online Booking Boat Club Road to Mumbai Taxi", "Sedan Hire Boat Club Road to Mumbai"],
    ["Private Cab Boat Club Road to Mumbai", "Chauffeur Driven Taxi Boat Club Road to Mumbai"],
    ["Family Cab Boat Club Road to Mumbai", "Corporate Cab Boat Club Road to Mumbai"],
    ["Reliable Cab Boat Club Road to Mumbai", "Fast Travel Cab Boat Club Road to Mumbai"],
    ["24/7 Cab Booking Boat Club Road to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Premium Cab Service from Boat Club Road to Mumbai",
        "WhyChoosedescription": "Enjoy a seamless and stylish travel experience from Boat Club Road to Mumbai with our premium cab service. Whether you’re heading to a corporate meeting, the airport, or a special event, we ensure timely pickups, luxurious comfort, and a hassle-free journey tailored to your needs."
    },
    {
        "WhyChooseheading": "High-Quality, Well-Maintained Fleet",
        "WhyChoosedescription": "Choose from our range of sedans, SUVs, and luxury vehicles—each thoroughly maintained, air-conditioned, and equipped for your comfort. Our vehicles are cleaned and sanitized before every trip, ensuring a pristine environment for your travel."
    },
    {
        "WhyChooseheading": "Experienced Chauffeurs with Professional Etiquette",
        "WhyChoosedescription": "Our trained drivers are punctual, courteous, and well-versed with the Boat Club Road to Mumbai route. They offer a discreet, safe, and comfortable driving experience while maintaining professional standards throughout the journey."
    },
    {
        "WhyChooseheading": "Transparent and All-Inclusive Fare Structure",
        "WhyChoosedescription": "With us, what you see is what you pay. Our pricing is inclusive of tolls, fuel, taxes, and driver allowance—no hidden charges, no last-minute surprises. We offer fair and transparent rates with premium service."
    },
    {
        "WhyChooseheading": "Flexible Booking Options and Itinerary Customization",
        "WhyChoosedescription": "Whether you’re booking a one-way trip, return ride, or a full-day rental, we accommodate your travel plans with flexible options. Customize pickup time, stopovers, and drop location as per your preferences."
    },
    {
        "WhyChooseheading": "Convenient Doorstep Pickup and Drop-off",
        "WhyChoosedescription": "We pick you up directly from your residence, hotel, or office on Boat Club Road and drop you at your exact location in Mumbai. Avoid crowded pickup points and travel at your own convenience with our door-to-door service."
    },
    {
        "WhyChooseheading": "Ideal for Business Travelers, VIPs, and Airport Transfers",
        "WhyChoosedescription": "Our cab service is a top choice for executives, VIPs, and travelers seeking premium comfort and punctuality. Whether you're heading to Mumbai Airport, a corporate event, or a luxury destination, we deliver an exceptional travel experience."
    },
    {
        "WhyChooseheading": "24/7 Booking Support with Real-Time Assistance",
        "WhyChoosedescription": "Need help with a booking, change in plans, or a last-minute request? Our support team is available 24/7 to assist you promptly, ensuring your travel experience is smooth from booking to drop-off."
    }
]












    }

const faqData = [
    {
        question: "How can I book a cab from Boat Club Road to Mumbai?",
        answer: "You can book a cab by calling Meghana Cab at +91 9075462128 or through our website for quick and easy booking."
    },
    {
        question: "What is the approximate travel time from Boat Club Road to Mumbai by cab?",
        answer: "The journey typically takes around 3 to 4 hours, depending on traffic and route conditions."
    },
    {
        question: "Do you offer one way and round trip cab services from Boat Club Road to Mumbai?",
        answer: "Yes, both one way and round trip services are available to fit your travel requirements."
    },
    {
        question: "What types of vehicles are available for Boat Club Road to Mumbai trips?",
        answer: "We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers."
    },
    {
        question: "Is the cab service from Boat Club Road to Mumbai available 24/7?",
        answer: "Yes, our services are available round the clock for your convenience."
    },
    {
        question: "What does the fare include for the Boat Club Road to Mumbai cab?",
        answer: "The fare covers fuel, tolls, and driver charges. Additional waiting or parking fees may apply."
    },
    {
        question: "Can I book a last-minute cab from Boat Club Road to Mumbai?",
        answer: "Yes, we accept last-minute bookings based on availability. Contact us directly for faster confirmation."
    },
    {
        question: "Is online booking available for Boat Club Road to Mumbai cabs?",
        answer: "Yes, you can easily book your cab online anytime through our website."
    },
    {
        question: "Can I request stops for meals or sightseeing during the journey?",
        answer: "Yes, stops can be arranged upon request. Please inform us when booking or inform the driver."
    },
    {
        question: "Are Meghana Cab drivers experienced on the Boat Club Road to Mumbai route?",
        answer: "Absolutely. Our drivers are professional, trained, and familiar with this route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent cab service from Boat Club Road to Mumbai. Timely, comfortable, and courteous driver.”',
    },
    {
        name: 'Ms. Sneha Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth and hassle-free booking experience. Clean car and professional driver.”',
    },
];


































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Boat Club Road to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/boat-club-road-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable cab service from Boat Club Road to Mumbai with Meghana Cabs. Choose from AC, SUV, sedan, and chauffeur-driven taxis for one-way or round trips. Available 24/7 with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1750",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/boat-club-road-to-mumbai-cab-service"
  }
};







    return (
        <div>

<Helmet>
  <title>Boat Club Road to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book reliable and affordable cab service from Boat Club Road to Mumbai with Meghana Cabs. Choose from AC, SUV, sedan, and chauffeur-driven taxis for one-way or round trips. Available 24/7 with easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Boat Club Road to Mumbai Taxi Booking, One Way Cab Boat Club Road to Mumbai, Round Trip Cab Boat Club Road to Mumbai, AC Cab Hire Boat Club Road to Mumbai, Budget Taxi Boat Club Road to Mumbai, SUV Cabs Boat Club Road to Mumbai, Online Booking Boat Club Road to Mumbai Taxi, Sedan Hire Boat Club Road to Mumbai, Private Cab Boat Club Road to Mumbai, Chauffeur Driven Taxi Boat Club Road to Mumbai, Family Cab Boat Club Road to Mumbai, Corporate Cab Boat Club Road to Mumbai, Reliable Cab Boat Club Road to Mumbai, Fast Travel Cab Boat Club Road to Mumbai, 24/7 Cab Booking Boat Club Road to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Boatclubroadmumbaicab;